// src/pages/Home.js
import React from 'react';
import HeroSection from '../components/HeroSection';
import HomeAbout from './HomeAbout';
// import WhyPartner from './WhyPartner';
// import StaffingSolutions from './StaffingSolutions';
// import AssociatedCompanies from './AssociatedCompanies';
// import TrustedSection from './TrustedSection';
import ClientCarousel from './ClientCarousel';
// import VideoSection from './VideoSection';

const Home = () => {
  return (
    <>
      <HeroSection />
      {/* Add more sections below if needed */}
      <HomeAbout/>
      {/* <WhyPartner/> */}
      {/* <StaffingSolutions/> */}
      {/* <AssociatedCompanies/> */}
      {/* <TrustedSection/> */}
      <ClientCarousel/>
      {/* <VideoSection/> */}
    </>
  );
};

export default Home;
